<div class="submission-container">
  <div class="d-flex flex-column gap-1">
    <div class="submission-name">{{ submissionName$ | async }}</div>
    <div *ngIf="submissionOwner$ | async as owner" class="submission-owner" i18n>Owner: {{ owner }}</div>
  </div>
  <app-status-pill class="mt-auto mb-auto" [statusPill]="submissionStatusPill$ | async" />
</div>
